import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import PageNotFound from '../Pages/PageNotFound/index';
import Products from '../Pages/Products/index';
import Transaction from '../Pages/Transaction/index';

const Routes = () => {
	return (
		<Router>
			<Switch>
				<Route path='/' exact>
					<Products />
				</Route>
				<Route path='/transaction/:result'>
					<Transaction />
				</Route>

				<Route path='*'>
					<PageNotFound />
				</Route>
			</Switch>
		</Router>
	);
};

export default Routes;
